/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const language = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1.16 6.094h2.992c.38 0 .736.278.829.648l.427 1.712a.856.856 0 0 1 .007.384.866.866 0 0 1-.836.679h-.615l-.329 1.647-.252 1.417m10.293-2.83a6.526 6.526 0 0 1-.593 1.22L15 15l-4.025-1.918a6.573 6.573 0 0 1-5.8.546A6.526 6.526 0 0 1 1.25 9.322a6.55 6.55 0 0 1-.09-3.228m12.517 3.658a6.529 6.529 0 0 0-.431-5.4A6.575 6.575 0 0 0 7.539 1a6.524 6.524 0 0 0-2.914.681A6.58 6.58 0 0 0 1.16 6.094m12.516 3.658h-2.343a.863.863 0 0 1-.843-.715l-.45-2.71h-.9a.868.868 0 0 1-.83-1.062l.427-1.711a.875.875 0 0 1 .83-.648h2.579"
    />
  </svg>
)
export default language
